import { api, STATUS_LABELS } from "@/lib/api";
import Barcode from "@/components/orders/Barcode";
import MarketplaceBadge from "@/components/orders/MarketplaceBadge";
import { fieldOrDash } from "@/components/orders/orderDetailUtils";

export default function OrderHeaderCard({ order, onReload }) {
  return (
    <div className="border border-black bg-white p-6 md:p-8 mb-5" data-testid="order-header">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
        <div className="lg:col-span-5">
          <div className="overline text-zinc-500 mb-2">PEDIDO BLING</div>
          <div className="flex items-center gap-3 flex-wrap mb-4">
            <div className="font-mono text-5xl md:text-6xl font-semibold leading-none">#{order.bling_number}</div>
            {order.marketplace_source && (
              <MarketplaceBadge marketplace={order.marketplace_source} size="md" />
            )}
          </div>
          <div className="flex items-center gap-3">
            <span className={`dot ${order.production_status}`} />
            <span className="text-sm font-semibold">{STATUS_LABELS[order.production_status]}</span>
          </div>
          <div className="mt-2 text-xs text-zinc-500 font-mono">
            {order.bling_situation_label && <span>{order.bling_situation_label}</span>}
          </div>
          {order.bling_number && (
            <div className="mt-4 inline-block bg-white p-2 border border-black" data-testid="barcode-container">
              <Barcode value={order.bling_number} height={50} fontSize={12} />
              <div className="text-[9px] uppercase tracking-widest text-zinc-500 text-center mt-1">
                escaneie para localizar o pedido
              </div>
            </div>
          )}
        </div>
        <div className="lg:col-span-7 grid grid-cols-2 gap-x-6 gap-y-3 text-sm">
          <div><div className="overline text-zinc-500 mb-1">CLIENTE</div><div className="font-semibold">{order.customer}</div></div>
          <div><div className="overline text-zinc-500 mb-1">DOCUMENTO</div><div className="font-mono">{fieldOrDash(order.customer_doc)}</div></div>
          <div><div className="overline text-zinc-500 mb-1">MARKETPLACE</div><div className="font-mono">{fieldOrDash(order.marketplace)}</div></div>
          <div><div className="overline text-zinc-500 mb-1">CATEGORIA</div><div>{fieldOrDash(order.category)}</div></div>
          <div><div className="overline text-zinc-500 mb-1">DATA PEDIDO</div><div className="font-mono">{(order.order_date || order.created_at) ? new Date(order.order_date || order.created_at).toLocaleDateString("pt-BR") : "—"}</div></div>
          <div>
            <div className="overline text-zinc-500 mb-1 flex items-center gap-1">
              DATA LIMITE DE ENVIO
              {order.exit_date_manual && <span className="text-[9px] text-[#FFC000] font-bold">· EDITADA</span>}
            </div>
            <input
              type="date"
              className="input font-mono text-sm py-1 px-2 w-full max-w-[170px]"
              value={(order.exit_date || "").slice(0, 10)}
              onChange={async (e) => {
                const next = e.target.value || null;
                try {
                  await api.put(`/orders/${order.id}/exit-date`, { exit_date: next });
                  onReload();
                } catch (err) {
                  alert(err?.response?.data?.detail || "Erro ao salvar data");
                }
              }}
              data-testid="exit-date-input"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
